"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[726],{

/***/ 73930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ HEADER_HIDE_SCROLL_OPTIONS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_AppBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42293);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_Toolbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10155);
/* harmony import */ var _mui_material_useScrollTrigger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8298);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61730);
// ** MUI Imports






// ** Util Import
const AppBar = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material_AppBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((param)=>{
    let { theme  } = param;
    return {
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(0, 6),
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        minHeight: "60px",
        transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        }
    };
});
const Toolbar = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material_Toolbar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        padding: "0 !important",
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        minHeight: "60px !important",
        transition: "padding .25s ease-in-out, box-shadow .25s ease-in-out, backdrop-filter .25s ease-in-out"
    };
});
// 与 ExpirationReminder banner 共用，保证下滑隐藏时同步上移
const HEADER_HIDE_SCROLL_OPTIONS = {
    threshold: 80,
    disableHysteresis: false
};
const LayoutAppBar = (props)=>{
    // ** Props
    const { settings , appBarProps , appBarContent: userAppBarContent  } = props;
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("(max-width:990px)");
    const scrollTrigger = (0,_mui_material_useScrollTrigger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        threshold: 0,
        disableHysteresis: true
    });
    const hideOnScroll = (0,_mui_material_useScrollTrigger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(HEADER_HIDE_SCROLL_OPTIONS);
    // ** Vars
    const { skin , appBar , appBarBlur , contentWidth  } = settings;
    const appBarFixedStyles = ()=>{
        return {
            background: "#F7F7F9"
        };
    };
    if (appBar === "hidden") {
        return null;
    }
    let userAppBarStyle = {};
    if (appBarProps && appBarProps.sx) {
        userAppBarStyle = appBarProps.sx;
    }
    const userAppBarProps = Object.assign({}, appBarProps);
    delete userAppBarProps.sx;
    // 移动端用 fixed + transform 隐藏，避免 sticky 滚动合成导致文字抖动
    const mobileHideSx = isMobile ? {
        top: 0,
        left: 0,
        right: 0,
        transform: hideOnScroll ? "translateY(-110%)" : "translateY(0)",
        pointerEvents: hideOnScroll ? "none" : "auto"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppBar, {
                elevation: 0,
                color: "default",
                className: "layout-navbar",
                sx: {
                    ...userAppBarStyle,
                    ...mobileHideSx
                },
                position: isMobile ? "fixed" : appBar === "fixed" ? "sticky" : "static",
                ...userAppBarProps,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Toolbar, {
                    className: "navbar-content-container",
                    sx: {
                        ...appBar === "fixed" && scrollTrigger && {
                            ...appBarFixedStyles()
                        },
                        ...contentWidth === "boxed" && {
                            "@media (min-width:1440px)": {
                                maxWidth: "calc(1440px - ".concat(theme.spacing(6), " * 2)")
                            }
                        }
                    },
                    children: userAppBarContent && userAppBarContent(props) || null
                })
            }),
            isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Toolbar, {
                sx: {
                    minHeight: "60px !important",
                    flexShrink: 0,
                    visibility: "hidden"
                }
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LayoutAppBar);


/***/ }),

/***/ 40726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material_useScrollTrigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8298);
/* harmony import */ var src_api_login_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53399);
/* harmony import */ var _src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95629);
/* harmony import */ var src_lib_getCountryAndIp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7174);
/* harmony import */ var src_core_layouts_components_vertical_appBar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73930);
/* harmony import */ var src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49354);
/* harmony import */ var src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22518);
/* harmony import */ var src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34556);
/* harmony import */ var src_utils_resolveUpgradeDeviceId__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43756);
/* harmony import */ var src_hooks_useRenewalPlans__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84325);
/* harmony import */ var src_utils_navigate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48551);
















const currencyMap = [
    {
        country: "IT",
        currency: "EUR"
    },
    {
        country: "FR",
        currency: "EUR"
    },
    {
        country: "ES",
        currency: "EUR"
    },
    {
        country: "BE",
        currency: "EUR"
    },
    {
        country: "DE",
        currency: "EUR"
    },
    {
        country: "NL",
        currency: "EUR"
    },
    {
        country: "PT",
        currency: "EUR"
    },
    {
        country: "HR",
        currency: "EUR"
    },
    {
        country: "GR",
        currency: "EUR"
    },
    {
        country: "AT",
        currency: "EUR"
    },
    {
        country: "BR",
        currency: "BRL"
    },
    {
        country: "AU",
        currency: "AUD"
    },
    {
        country: "CA",
        currency: "CAD"
    },
    {
        country: "KR",
        currency: "KRW"
    },
    {
        country: "GB",
        currency: "GBP"
    },
    {
        country: "IN",
        currency: "INR"
    },
    {
        country: "JP",
        currency: "JPY"
    },
    {
        country: "TR",
        currency: "TRY"
    },
    {
        country: "ZA",
        currency: "ZAR"
    },
    {
        country: "RO",
        currency: "RON"
    },
    {
        country: "CH",
        currency: "CHF"
    },
    {
        country: "MX",
        currency: "MXN"
    },
    {
        country: "MY",
        currency: "MYR"
    },
    {
        country: "SG",
        currency: "SGD"
    },
    {
        country: "BG",
        currency: "BGN"
    },
    {
        country: "IL",
        currency: "ILS"
    },
    {
        country: "PL",
        currency: "PLN"
    },
    {
        country: "NO",
        currency: "NOK"
    },
    {
        country: "SE",
        currency: "SEK"
    },
    {
        country: "HU",
        currency: "HUF"
    },
    {
        country: "CZ",
        currency: "CZK"
    },
    {
        country: "AR",
        currency: "ARS"
    },
    {
        country: "TH",
        currency: "THB"
    },
    {
        country: "NZ",
        currency: "NZD"
    }
];
const fallbackRates = {
    AUD: 1.4193,
    BGN: 5.2484,
    BRL: 5.283,
    CAD: 1.3624,
    CHF: 0.78017,
    CNY: 6.9011,
    CZK: 20.998,
    DKK: 6.4311,
    EUR: 0.86073,
    GBP: 0.74841,
    HKD: 7.8209,
    HUF: 333.58,
    IDR: 16909,
    ILS: 3.0734,
    INR: 91.65,
    ISK: 124.55,
    JPY: 157.54,
    KRW: 1475.79,
    MXN: 17.6338,
    MYR: 3.943,
    NOK: 9.6523,
    NZD: 1.689,
    PHP: 58.625,
    PLN: 3.6775,
    RON: 4.384,
    SEK: 9.1999,
    SGD: 1.2772,
    THB: 31.665,
    TRY: 43.994,
    ZAR: 16.5028
};
const readDeviceUser = ()=>{
    try {
        return JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
    } catch (e) {
        return {};
    }
};
const getSelectedDeviceId = ()=>{
    const deviceUser = readDeviceUser();
    const id = deviceUser.device_id != null && deviceUser.device_id !== "" ? deviceUser.device_id : deviceUser.id;
    return id != null && id !== "" ? id : null;
};
/**
 * 定位当前设备：先按 device_id / id，再按 iCloud 账号兜底。
 * 兜底是必要的：部分写入 DeviceUser 的路径（绑定流程等）不带 device_id，
 * 只按 id 匹配会拿不到设备 → 续费弹窗拿不到当前订单（套餐与价格全空）。
 */ const resolveCurrentDevice = function() {
    let deviceList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const list = Array.isArray(deviceList) ? deviceList : [];
    if (!list.length) return null;
    const selectedId = getSelectedDeviceId();
    if (selectedId != null) {
        const byId = list.find((item)=>String(item.id) === String(selectedId) || String(item.device_id) === String(selectedId));
        if (byId) return byId;
    }
    const deviceUser = readDeviceUser();
    const account = deviceUser.username || deviceUser.iCloud_username;
    if (account) {
        return list.find((item)=>item.iCloud_username === account || item.username === account) || null;
    }
    return null;
};
const ExpirationReminder = (param)=>{
    let { orders , paymentFallbackOnly =false  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const [isDisplay, setIsDisplay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isExpired, setIsExpired] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [remainingDays, setRemainingDays] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [expirationDays, setExpirationDays] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [serverDate, setServerDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    // 控制弹窗在“将到期”与“已过期”两种状态下的文案
    const [isExpiredPopup, setIsExpiredPopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isDisplay2, setIsDisplay2] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [order, setOrder] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const username = ((ref = JSON.parse(localStorage.getItem("DeviceUser"))) === null || ref === void 0 ? void 0 : ref.username) || "";
    const [isDisplayPayment, setIsDisplayPayment] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [checkID, setCheckID] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [isDisplayPlan, setIsDisplayPlan] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [deviceId, setDeviceId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const deviceUserKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const { plans , planIndex , setPlanIndex , selectedPlan  } = (0,src_hooks_useRenewalPlans__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        orderId: order === null || order === void 0 ? void 0 : order.id,
        expireTime: order === null || order === void 0 ? void 0 : order.expire_time,
        productName: order === null || order === void 0 ? void 0 : order.product_name,
        enabled: (order === null || order === void 0 ? void 0 : order.id) != null && (order === null || order === void 0 ? void 0 : order.id) !== ""
    });
    const applyOrderRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((deviceOrId, orderList)=>{
        if (!(orderList === null || orderList === void 0 ? void 0 : orderList.length)) return;
        const device = deviceOrId && typeof deviceOrId === "object" ? deviceOrId : null;
        const deviceUser = readDeviceUser();
        const id = device ? device.id : deviceOrId;
        // 与 Dashboard 卡片同一套匹配：order_id → device_id（多张取最晚过期）→ iCloud 账号
        const row = (0,src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_13__/* .resolveDeviceOrder */ .mw)({
            orders: orderList,
            deviceUser,
            device,
            deviceId: id
        });
        if (row) {
            setOrder(row);
            setCheckID((row === null || row === void 0 ? void 0 : row.bill_card) ? 0 : 1);
        }
    }, []);
    // 用户已在弹窗里选好套餐 → 直达官网支付页（与 my account 的「添加卡」一致，见 71f5416），
    // 少一步「再选一次套餐」；拿不到套餐编号时退回官网套餐页兜底，避免点了没反应。
    // 必须带上当前设备的「设备包 id」，否则官网建单会另开一个设备包（多绑定一个 package）。
    const getRenewCheckoutHref = ()=>{
        const deviceId = (0,src_utils_resolveUpgradeDeviceId__WEBPACK_IMPORTED_MODULE_14__/* .resolveUpgradeDeviceId */ .C7)(deviceUserKey);
        return (0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_10__/* .buildMsafelyRenewCheckoutHref */ .T2)({
            locale,
            productId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productId,
            deviceId
        }) || (0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_10__/* .buildMsafelyPurchaseHref */ .NA)({
            locale,
            deviceId
        });
    };
    const [isDisplayResult, setIsDisplayResult] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [paymentResult, setPaymentResult] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("success");
    const [errorType, setErrorType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const updateExpirationFromServer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((expireTimeRaw, serverTimeRaw)=>{
        const expireTime = expireTimeRaw == null || expireTimeRaw === "" ? NaN : new Date(expireTimeRaw).getTime();
        const numericServerTime = Number(serverTimeRaw);
        const parsedServerTime = Number.isFinite(numericServerTime) ? numericServerTime < 1e12 ? numericServerTime * 1000 : numericServerTime : new Date(serverTimeRaw).getTime();
        // Use server time when available; a server-time outage should not hide the reminder.
        const nowTime = Number.isFinite(parsedServerTime) && parsedServerTime > 0 ? parsedServerTime : Date.now();
        if (!Number.isFinite(expireTime) || expireTime <= 0) {
            setIsExpired(false);
            setIsDisplay(false);
            setIsDisplay2(false);
            setRemainingDays(0);
            setExpirationDays(0);
            setServerDate("");
            return;
        }
        const nowDate = new Date(nowTime).toISOString().slice(0, 10);
        const closeDate = localStorage.getItem("closeExpirationReminder-".concat(username));
        setServerDate(nowDate);
        if (expireTime > nowTime) {
            setIsExpired(false);
            const remaining = Math.ceil((expireTime - nowTime) / (1000 * 60 * 60 * 24));
            setIsDisplay(remaining <= 7 && nowDate !== closeDate);
            setRemainingDays(remaining);
            if (remaining <= 3) {
                const key = "DisplayExpiredPopup-".concat(username);
                const savedDate = localStorage.getItem(key);
                if (savedDate === nowDate) {
                    setIsDisplay2(false);
                } else {
                    setIsExpiredPopup(false);
                    setIsDisplay2(true);
                    localStorage.setItem(key, nowDate);
                }
            } else {
                setIsDisplay2(false);
            }
        } else {
            setIsExpired(true);
            setIsDisplay(true);
            setExpirationDays(Math.ceil((nowTime - expireTime) / (1000 * 60 * 60 * 24)));
            setIsDisplay2(false);
        }
    }, [
        username
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const init = async ()=>{
            const [res, serverTimeRes] = await Promise.all([
                (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getUserAccountDevice)({
                    page: 1,
                    pageSize: 10
                }).catch(()=>null),
                (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getServerTime)().catch(()=>null)
            ]);
            if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                const device = resolveCurrentDevice(res.data);
                const deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}");
                // 解析到期时间：优先 DeviceUser，无效再回退接口 device；都无效则不展示提醒（避免「0 days」假显示）
                const parseExpireMs = (raw)=>{
                    if (raw == null || raw === "") return NaN;
                    const ms = new Date(raw).getTime();
                    return Number.isFinite(ms) && ms > 0 ? ms : NaN;
                };
                const expireTime = [
                    deviceUser.expire_time,
                    device === null || device === void 0 ? void 0 : device.expire_time
                ].map(parseExpireMs).find(Number.isFinite);
                if (device) {
                    var ref;
                    setDeviceId(device.id);
                    if (orders === undefined) {
                        const result = await (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getUserAccountOrder)({
                            page: 1,
                            pageSize: 9999
                        });
                        applyOrderRow(device, result.data);
                    }
                    // 详情页只复用「续费失败 → 选择支付方式」能力，不重复展示首页到期 Banner。
                    if (paymentFallbackOnly) return;
                    updateExpirationFromServer(expireTime, serverTimeRes === null || serverTimeRes === void 0 ? void 0 : (ref = serverTimeRes.data) === null || ref === void 0 ? void 0 : ref.server_time);
                }
            }
        };
        init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviceUserKey,
        applyOrderRow,
        isDisplayPayment,
        paymentFallbackOnly,
        updateExpirationFromServer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const selectedDeviceId = getSelectedDeviceId();
        if (selectedDeviceId) setDeviceId(selectedDeviceId);
        if (!Array.isArray(orders) || orders.length === 0) return;
        const id = selectedDeviceId || deviceId;
        if (id) applyOrderRow(id, orders);
    }, [
        deviceId,
        orders,
        applyOrderRow,
        isDisplayPayment
    ]);
    const preventScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const prevBodyOverflowRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const prevBodyOverflowXRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isDisplay2 || isDisplayPayment) {
            // 兼容“只阻止滚动但滚动条仍可见”的情况：直接隐藏 body 滚动条
            if (prevBodyOverflowRef.current === null) {
                prevBodyOverflowRef.current = document.body.style.overflow;
                prevBodyOverflowXRef.current = document.body.style.overflowX;
            }
            document.body.style.setProperty("overflow", "hidden", "important");
            document.body.style.setProperty("overflow-x", "hidden", "important");
            document.addEventListener("wheel", preventScroll, {
                passive: false
            });
            document.addEventListener("touchmove", preventScroll, {
                passive: false
            });
        } else {
            document.removeEventListener("wheel", preventScroll);
            document.removeEventListener("touchmove", preventScroll);
            // 恢复 body 样式
            if (prevBodyOverflowRef.current !== null) {
                document.body.style.overflow = prevBodyOverflowRef.current;
                var _current;
                document.body.style.overflowX = (_current = prevBodyOverflowXRef.current) !== null && _current !== void 0 ? _current : "";
                prevBodyOverflowRef.current = null;
                prevBodyOverflowXRef.current = null;
            }
        }
        return ()=>{
            document.removeEventListener("wheel", preventScroll);
            document.removeEventListener("touchmove", preventScroll);
            if (prevBodyOverflowRef.current !== null) {
                document.body.style.overflow = prevBodyOverflowRef.current;
                var _current;
                document.body.style.overflowX = (_current = prevBodyOverflowXRef.current) !== null && _current !== void 0 ? _current : "";
                prevBodyOverflowRef.current = null;
                prevBodyOverflowXRef.current = null;
            }
        };
    }, [
        isDisplay2,
        isDisplayPayment,
        preventScroll
    ]);
    const [showAnimation, setShowAnimation] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let timer;
        if (isDisplayResult) {
            // 触发显示动画
            setShowAnimation(true);
            // 三秒后开始消失动画
            timer = setTimeout(()=>{
                setShowAnimation(false) // 先做消失动画
                ;
            }, 3000);
        }
        return ()=>clearTimeout(timer);
    }, [
        isDisplayResult
    ]);
    // 当消失动画结束再隐藏整个 div
    const handleTransitionEnd = ()=>{
        if (!showAnimation) {
            setIsDisplayResult(false);
        }
    };
    const [currency, setCurrency] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("USD") // 当前选择货币
    ;
    const [exchangeRate, setExchangeRate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1) // 美元转换当前货币汇率
    ;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const initData = async ()=>{
            try {
                var ref;
                const ip = await (0,src_lib_getCountryAndIp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
                const lowerCountry = (ip === null || ip === void 0 ? void 0 : (ref = ip.country) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "us";
                let currentCurrency = "USD";
                if (lowerCountry !== "us") {
                    const match = currencyMap.find((item)=>item.country.toLowerCase() === lowerCountry);
                    currentCurrency = match ? match.currency : "USD";
                }
                setCurrency(currentCurrency);
                if (currentCurrency !== "USD") {
                    fetch("https://api.frankfurter.app/latest?from=USD&to=".concat(currentCurrency)).then((res)=>res.json()).then((data)=>{
                        var ref;
                        const rate = (ref = data.rates) === null || ref === void 0 ? void 0 : ref[currentCurrency];
                        if (rate) {
                            setExchangeRate(rate);
                        } else {
                            setExchangeRate(fallbackRates[currentCurrency] || 1);
                        }
                    }).catch((err)=>{
                        ;
                        setExchangeRate(fallbackRates[currentCurrency] || 1);
                    });
                } else {
                    setExchangeRate(1);
                }
            } catch (error) {
                ;
            }
        };
        if (isDisplayPayment) initData();
    }, [
        isDisplayPayment
    ]);
    const handleRenewalSuccess = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async ()=>{
        setIsDisplay(false);
        setIsDisplay2(false);
        setIsDisplayPayment(false);
        setPaymentResult("success");
        setIsDisplayResult(true);
        // grace（过期 ≤30 天）常走本组件：banner 续费 / Guide 失败兜底。
        // refreshSubscriptionExpire 只 bump revision、不动 Redux deviceUser，
        // 过期 banner / 遮罩会继续停在「已过期」视图，必须整页刷新。
        (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_9__/* .reloadAfterRenewSuccess */ .dZ)();
        try {
            var ref;
            const [deviceRes, orderRes, serverTimeRes] = await Promise.all([
                (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getUserAccountDevice)({
                    page: 1,
                    pageSize: 10
                }),
                (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getUserAccountOrder)({
                    page: 1,
                    pageSize: 9999
                }),
                (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_5__.getServerTime)().catch(()=>null)
            ]);
            if ((deviceRes === null || deviceRes === void 0 ? void 0 : deviceRes.code) !== 0) {
                await (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_9__/* .refreshSubscriptionExpire */ .Af)({
                    dispatch
                });
                return;
            }
            const device = resolveCurrentDevice(deviceRes.data);
            if (device) setDeviceId(device.id);
            const row = device ? (0,src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_13__/* .resolveDeviceOrder */ .mw)({
                orders: orderRes === null || orderRes === void 0 ? void 0 : orderRes.data,
                deviceUser: readDeviceUser(),
                device,
                deviceId: device.id,
                iCloudUsername: device.iCloud_username
            }) : null;
            var ref1;
            const expireTimeRaw = (ref1 = row === null || row === void 0 ? void 0 : row.expire_time) !== null && ref1 !== void 0 ? ref1 : device === null || device === void 0 ? void 0 : device.expire_time;
            await (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_9__/* .refreshSubscriptionExpire */ .Af)({
                dispatch,
                expireTime: expireTimeRaw
            });
            updateExpirationFromServer(expireTimeRaw, serverTimeRes === null || serverTimeRes === void 0 ? void 0 : (ref = serverTimeRes.data) === null || ref === void 0 ? void 0 : ref.server_time);
            if (row) {
                applyOrderRow(device, orderRes.data);
            }
        } catch (e) {
            // reminders already dismissed; sync is best-effort
            await (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_9__/* .refreshSubscriptionExpire */ .Af)({
                dispatch
            });
        }
    }, [
        dispatch,
        applyOrderRow,
        updateExpirationFromServer
    ]);
    const RenewSubscription = async (id)=>{
        try {
            var ref;
            const renewId = (ref = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productId) !== null && ref !== void 0 ? ref : await (0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_10__/* .fetchRenewProductIdForOrder */ .R4)(order);
            if (!renewId) {
                setIsDisplayPayment(true);
                return;
            }
            const res = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .extendSubscriptionTime */ .rK)({
                merchant_no: order.merchant_no,
                renewId,
                order_type: id === 0 ? 272 : 273
            });
            if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                await handleRenewalSuccess();
            } else {
                setPaymentResult("error");
                setErrorType(res.msg);
                setIsDisplayPayment(true);
            }
        } catch (error) {
            var ref1, ref2;
            ;
            // HTTP 500（如当前支付方式不支持续费）会被 Axios 抛到 catch；
            // 与业务失败码保持一致，继续展示新支付方式兜底弹窗。
            setPaymentResult("error");
            setErrorType((error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.msg) || (error === null || error === void 0 ? void 0 : error.msg) || t("Payment failed"));
            setIsDisplayPayment(true);
        }
    };
    const handleClick = async ()=>{
        if (checkID === 0 && !(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productId)) return;
        if (checkID === 0) {
            try {
                const res = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .extendSubscriptionTime */ .rK)({
                    merchant_no: order.merchant_no,
                    renewId: selectedPlan.productId
                });
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    await handleRenewalSuccess();
                } else {
                    setPaymentResult("error");
                    setErrorType(res.msg);
                    setIsDisplayResult(true);
                }
            } catch (error) {
                ;
            }
        } else {
            (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_12__/* .navigateTo */ .T8)(getRenewCheckoutHref());
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handler = (event)=>{
            var // 标记「失败已由本弹窗接管」：调用方（如 ExpiredPurchaseGuide）会据此
            // 判断无需再跳官网，避免失败时把用户甩到价格页
            ref;
            event === null || event === void 0 ? void 0 : (ref = event.preventDefault) === null || ref === void 0 ? void 0 : ref.call(event);
            setIsDisplayPayment(true);
        };
        window.addEventListener("renewalFailed", handler);
        return ()=>{
            window.removeEventListener("renewalFailed", handler);
        };
    }, []);
    const ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 移动端套餐列表是独立的底部面板（不在 ref 内），需要单独判断
    const mobilePlanRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const bannerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [bannerHeight, setBannerHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 与 header 同一套下滑判定，用 transform 上移，避免改 sticky top 导致抖动
    const hideOnScroll = (0,_mui_material_useScrollTrigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(src_core_layouts_components_vertical_appBar__WEBPACK_IMPORTED_MODULE_8__/* .HEADER_HIDE_SCROLL_OPTIONS */ .X);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            var ref, ref1;
            const target = event.target;
            // 桌面下拉与移动端底部面板是两套 DOM，移动端面板不在 ref 内。
            // 只判断 ref 时，按下（mousedown）会先把面板收起（display:none），
            // 导致随后的 click 无处派发，套餐选不中。
            if (((ref = ref5.current) === null || ref === void 0 ? void 0 : ref.contains(target)) || ((ref1 = mobilePlanRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) return;
            setIsDisplayPlan(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // fixed 后测量高度做占位
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(()=>{
        if (!isDisplay) {
            setBannerHeight(0);
            return;
        }
        const el = bannerRef.current;
        if (!el) return;
        const updateHeight = ()=>setBannerHeight(el.offsetHeight);
        updateHeight();
        const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(updateHeight) : null;
        ro === null || ro === void 0 ? void 0 : ro.observe(el);
        return ()=>{
            return ro === null || ro === void 0 ? void 0 : ro.disconnect();
        };
    }, [
        isDisplay,
        remainingDays,
        isExpired,
        locale
    ]);
    var ref6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !paymentFallbackOnly && isDisplay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full -mt-3 mb-5 Header5:big:mt-[-60px] bigs:mt-[-90px] smjs:mt-[-40px] smjs:mb-[40px]",
                        style: {
                            height: bannerHeight || 72
                        },
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: bannerRef,
                        className: 'fixed top-[60px] left-0 right-0 z-[1099] smjs:left-[300px] w-auto mx-0 mt-0 mb-0 transition-transform duration-[225ms] ease-[cubic-bezier(0,0,0.2,1)] smjs:bg-[url("/image/banner/banner-pc-bg.svg")] smj:bg-[url("/image/banner/banner-phone-bg.svg")] bg-no-repeat bg-center bg-cover flex smj:flex-col justify-center items-center py-[11px] smj:py-2 smjs:px-5 '.concat(hideOnScroll ? "smj:-translate-y-[60px]" : "translate-y-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/image/banner/banner.png",
                                        width: 26,
                                        height: 26,
                                        alt: "",
                                        className: "smj:w-[18px] smj:h-[18px] animate-[swingClock_4s_cubic-bezier(0.4,0,0.2,1)_infinite]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "ml-4 smj:ml-2 text-[14px] smj:text-[12px] leading-[20px] smj:leading-[18px] font-[500] text-white",
                                        children: [
                                            isExpired ? t("Your monitoring plan expired") : t("Your monitoring plan will expire in"),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[#FFCF55] font-[600]",
                                                children: isExpired ? "".concat(expirationDays, " ").concat(t("days ago")) : "".concat(remainingDays, " ").concat(t("days"), ".")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "smj:hidden",
                                                children: [
                                                    " ",
                                                    isExpired ? t("and is currently in the grace period Please renew it as soon as possible otherwise the service will be interrupted") : t("Please renew promptly to avoid service interruption")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "smjs:ml-[48px] w-auto h-[32px] smj:h-[28px] px-5 bg-[#FFCF55] rounded-[16px] text-[14px] smj:text-[12px] text-[#282938] smj:mt-2 flex-shrink-0",
                                onClick: ()=>{
                                    RenewSubscription(0);
                                },
                                children: t("Renew Now")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: "/image/banner/close.svg",
                                alt: "",
                                width: 20,
                                height: 20,
                                className: "smj:w-4 smj:h-4 absolute right-6 top-[17px] smj:top-2 smj:right-2 cursor-pointer ".concat(isExpired && "hidden"),
                                onClick: ()=>{
                                    setIsDisplay(false);
                                    if (serverDate) localStorage.setItem("closeExpirationReminder-".concat(username), serverDate);
                                }
                            })
                        ]
                    })
                ]
            }),
            !paymentFallbackOnly && isDisplay2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed bottom-0 right-0 top-[60px] z-[1200] bg-[#00000080] smj:left-0 smjs:left-[300px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mx-auto mt-[280px] smj:mt-[25vh] w-[550px] smj:w-[calc(100vw-32px)] h-auto p-8 smj:pt-10 smj:pb-6 smj:px-6 bg-white rounded-[12px] smjs:translate-x-[-150px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: "/image/banner/warn.svg",
                            alt: "",
                            width: 48,
                            height: 48,
                            className: "mx-auto"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-3 font-[600] text-[20px] smj:text-[18px] leading-[28px] smj:leading-[26px] text-[#282938] text-center",
                            children: isExpiredPopup ? t("Your monitoring subscription has expired") : t("Your monitoring subscription is about to expire")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-6 text-[15px] leading-[24px] smj:text-[14px] smj:leading-[22px] text-[#484B60] text-start",
                            children: isExpiredPopup ? "".concat(t("Your"), " MSAFELY ").concat(((order === null || order === void 0 ? void 0 : (ref1 = order.product_name) === null || ref1 === void 0 ? void 0 : ref1.match(/\d+/)) || [
                                "1"
                            ])[0]).concat(t("-Month Premium Subscription expired on"), " ").concat(order === null || order === void 0 ? void 0 : (ref2 = order.expire_time) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 10), ". ").concat(t("New data is no longer being updated Please renew promptly to restore all features All data will be deleted 30 days after expiration")) : "".concat(t("Your"), " MSAFELY ").concat(((order === null || order === void 0 ? void 0 : (ref3 = order.product_name) === null || ref3 === void 0 ? void 0 : ref3.match(/\d+/)) || [
                                "1"
                            ])[0]).concat(t("-Month Premium Subscription expired on"), " ").concat(order === null || order === void 0 ? void 0 : (ref4 = order.expire_time) === null || ref4 === void 0 ? void 0 : ref4.slice(0, 10), ". ").concat(t("New data is no longer being updated Please renew promptly to restore all features All data will be deleted 30 days after expiration"))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "mt-6 w-auto h-[42px] px-10 bg-[#FFCF55] rounded-[40px] text-[14px] text-[#282938] mx-auto block font-[600]",
                            onClick: ()=>{
                                RenewSubscription(1);
                            },
                            children: t("Extend Subscription")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: "/image/banner/close.svg",
                            alt: "",
                            width: 24,
                            height: 24,
                            className: "smj:w-5 smj:h-5 absolute top-3 right-3 cursor-pointer",
                            onClick: ()=>{
                                setIsDisplay2(false);
                            }
                        })
                    ]
                })
            }),
            isDisplayPayment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed bottom-0 right-0 top-[60px] z-[1200] bg-[#00000080] smj:left-0 smjs:left-[300px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mx-auto mt-[280px] smj:mt-[25vh] w-[550px] smj:w-[calc(100vw-32px)] h-auto p-6 bg-white rounded-[10px] smjs:translate-x-[-150px] shadow-[0px_6px_14px_0px_#28293826]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "font-[600] text-[18px] leading-[26px] smj:text-[16px] smj:leading-[24px] text-[#282938]",
                            children: [
                                t("Choose your payment method"),
                                ":"
                            ]
                        }),
                        (order === null || order === void 0 ? void 0 : order.bill_card) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-4 mb-3 w-full h-[36px] flex items-center rounded-[6px] cursor-pointer ".concat(checkID === 0 ? "bg-[#454CFF1A] [box-shadow:0px_0px_0px_1px_#454CFF]" : "bg-[#F4F5F6]"),
                            onClick: ()=>{
                                setCheckID(0);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "/extreme/card.webp",
                                    alt: "card",
                                    width: 32,
                                    height: 22,
                                    className: "!w-[32px] !h-[22px] ml-3 mr-[15px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#454CFF] text-[14px] font-[500]",
                                    children: [
                                        "**** **** **** ",
                                        order.bill_card
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-[36px] flex items-center rounded-[6px] cursor-pointer ".concat(checkID === 1 ? "bg-[#454CFF1A] [box-shadow:0px_0px_0px_1px_#454CFF]" : "bg-[#F4F5F6]"),
                            onClick: ()=>{
                                // setCheckID(1)
                                (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_12__/* .navigateTo */ .T8)(getRenewCheckoutHref());
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[#454CFF] text-[13px] ml-3 font-[500]",
                                children: [
                                    "+ ",
                                    t("Add another card or payment method")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "font-[600] text-[18px] leading-[26px] smj:text-[16px] smj:leading-[24px] text-[#282938] mt-4 mb-3",
                            children: [
                                t("Order details"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between items-center text-[14px] leading-[20px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#9198AD]",
                                    children: [
                                        t("Youre getting"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[#2A313B] text-end",
                                    children: t("Subscription extension")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between text-[14px] leading-[20px] my-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#9198AD] flex-shrink-0",
                                    children: [
                                        t("You Plan"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-start relative cursor-pointer",
                                    ref: ref5,
                                    onClick: ()=>{
                                        setIsDisplayPlan(!isDisplayPlan);
                                        if (!isDisplayPlan) {}
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-[#2A313B] text-end",
                                            children: [
                                                "Msafely ",
                                                (ref6 = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.months) !== null && ref6 !== void 0 ? ref6 : "-",
                                                t("-Month Premium Subscription")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: "/image/banner/more-less.svg",
                                            alt: "",
                                            width: 14,
                                            height: 14,
                                            className: "ml-3 smj:ml-[5px] mt-[3px] flex-shrink-0 transition-transform duration-300 ease-in-out ".concat(isDisplayPlan ? "rotate-180" : "rotate-0")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "smj:hidden absolute z-[1201] top-[28px] right-[-16px] w-[190px] h-auto !rounded-[4px] overflow-hidden bg-white shadow-[0px_0px_8px_0px_#00000026] ".concat(isDisplayPlan || "hidden"),
                                            children: plans.map((plan, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "p-[6px_9px_6px_12px] flex justify-between items-center ".concat(planIndex === index ? "bg-[#F5F5F5]" : ""),
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        setPlanIndex(index);
                                                        setIsDisplayPlan(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-[#222222] text-[14px] leading-[21px]",
                                                                    children: t(plan.periodKey)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: "text-[#666666] text-[12px] leading-[18px]",
                                                                    children: [
                                                                        currency === "USD" ? "US$" : currency,
                                                                        (Number(plan.monthlyPrice) * exchangeRate).toFixed(2),
                                                                        "/",
                                                                        t("mo"),
                                                                        plan.showOriginal && plan.monthlyOriginal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                                                                            className: "ml-1 opacity-50",
                                                                            children: (Number(plan.monthlyOriginal) * exchangeRate).toFixed(2)
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                            src: "/image/banner/right.svg",
                                                            alt: "",
                                                            width: 12,
                                                            height: 12,
                                                            className: "".concat(planIndex === index ? "block" : "hidden")
                                                        })
                                                    ]
                                                }, plan.productId))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "fixed inset-0 w-full h-full bg-[#00000066] z-[1201] smjs:hidden ".concat(isDisplayPlan || "hidden"),
                                    onClick: ()=>setIsDisplayPlan(false),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: mobilePlanRef,
                                        className: "absolute bottom-0 right-0 left-0 w-full h-auto bg-white",
                                        onClick: (e)=>e.stopPropagation(),
                                        children: plans.map((plan, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "p-[8px_18px_8px_12px] flex justify-between items-center ".concat(planIndex === index ? "bg-[#F5F5F5]" : "bg-white"),
                                                onClick: ()=>{
                                                    setPlanIndex(index);
                                                    setIsDisplayPlan(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[#222222] text-[14px] leading-[21px]",
                                                                children: t(plan.periodKey)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                className: "text-[#666666] text-[12px] leading-[18px]",
                                                                children: [
                                                                    currency === "USD" ? "US$" : currency,
                                                                    (Number(plan.monthlyPrice) * exchangeRate).toFixed(2),
                                                                    "/",
                                                                    t("mo"),
                                                                    plan.showOriginal && plan.monthlyOriginal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                                                                        className: "ml-1 opacity-50",
                                                                        children: (Number(plan.monthlyOriginal) * exchangeRate).toFixed(2)
                                                                    }) : null
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        src: "/image/banner/right.svg",
                                                        alt: "",
                                                        width: 12,
                                                        height: 12,
                                                        className: "".concat(planIndex === index ? "block" : "hidden")
                                                    })
                                                ]
                                            }, plan.productId))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between items-center text-[14px] leading-[20px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#9198AD]",
                                    children: [
                                        t("Extension period"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[#2A313B]",
                                    children: selectedPlan ? t(selectedPlan.periodLabelKey) : "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between items-center text-[14px] leading-[20px] mt-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#9198AD]",
                                    children: [
                                        t("Monthly price"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[#2A313B]",
                                    children: [
                                        currency === "USD" ? "US$" : currency,
                                        selectedPlan ? (Number(selectedPlan.monthlyPrice) * exchangeRate).toFixed(2) : "-",
                                        (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.showOriginal) && selectedPlan.monthlyOriginal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                                            className: "ml-2 opacity-50",
                                            children: (Number(selectedPlan.monthlyOriginal) * exchangeRate).toFixed(2)
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex smj:flex-col justify-between items-center mt-6 font-[600]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "w-[240px] smj:w-full h-[42px] border-[1px] border-[#454CFF] rounded-[40px] flex justify-center items-center text-[#454CFF] text-[14px] smj:mt-[17px] smj:order-1",
                                    onClick: ()=>{
                                        setIsDisplayPayment(false);
                                    },
                                    children: t("Cancel")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "w-[240px] smj:w-full h-[42px] bg-[#FFCF55] rounded-[40px] flex justify-center items-center text-[#282938] text-[14px] smj:order-0 disabled:opacity-50 disabled:cursor-not-allowed",
                                    disabled: checkID === 0 && !(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productId),
                                    onClick: ()=>{
                                        handleClick();
                                    },
                                    children: t("Confirm")
                                })
                            ]
                        })
                    ]
                })
            }),
            isDisplayResult && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed z-[1201] top-[60px] left-1/2 translate-x-[calc(-50%+150px)] smj:translate-x-[-50%] w-[400px] smj:w-[calc(100vw-32px)] h-auto bg-white rounded-[8px] p-3 smj:py-2 shadow-[0px_1px_6px_0px_#28293826] transform transition-all duration-300 ease-in-out ".concat(showAnimation ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"),
                onTransitionEnd: handleTransitionEnd,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: paymentResult === "success" ? "/image/success.svg" : paymentResult === "error" ? "/image/error.svg" : paymentResult === "warn" ? "/image/warn.svg" : paymentResult === "remind" ? "/image/remind.svg" : "",
                            alt: "",
                            width: 24,
                            height: 24,
                            className: "w-[24px] h-[24px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[16px] leading-[24px] font-[600] text-[#282938]",
                                    children: paymentResult === "success" ? t("Successful") : paymentResult === "error" ? t("Payment failed") : paymentResult === "warn" ? t("Insufficient balance") : paymentResult === "remind" ? t("Duplicate payment") : t("Other")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[14px] leading-[22px] text-[#1D2129]",
                                    children: paymentResult === "success" ? t("You have successfully paid") : paymentResult === "error" ? errorType : t("No network")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExpirationReminder);


/***/ }),

/***/ 84325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22518);



/**
 * 拉取 plans-by-order 套餐并映射展示价。
 * - 常规续费：传 orderId
 * - 全部超 30 天：不传 order_id，后端返回新买产品/价格
 */ const useRenewalPlans = function() {
    let { orderId , expireTime , productName , enabled =true , forceExpiredOver =false , omitOrderId =false , defaultMonths =1  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [plans, setPlans] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [planIndex, setPlanIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const hasOrderId = orderId != null && orderId !== "";
        if (!enabled || !omitOrderId && !hasOrderId) {
            setPlans([]);
            return undefined;
        }
        let cancelled = false;
        const load = async ()=>{
            setLoading(true);
            try {
                const params = omitOrderId || !hasOrderId ? {} : {
                    order_id: orderId
                };
                const res = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getPlansByOrder */ .hV)(params);
                if (cancelled) return;
                const list = (res === null || res === void 0 ? void 0 : res.code) === 0 && Array.isArray(res.data) ? res.data : [];
                const mapped = (0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_2__/* .mapRenewalPlans */ .mH)(list, expireTime, {
                    forceExpiredOver
                });
                setPlans(mapped);
                setPlanIndex((0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_2__/* .resolvePlanIndex */ .TR)(mapped, productName, {
                    defaultMonths
                }));
            } catch (error) {
                ;
                if (!cancelled) {
                    setPlans([]);
                }
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return ()=>{
            cancelled = true;
        };
    }, [
        orderId,
        expireTime,
        productName,
        enabled,
        forceExpiredOver,
        omitOrderId,
        defaultMonths
    ]);
    const selectedPlan = plans[planIndex] || null;
    return {
        plans,
        loading,
        planIndex,
        setPlanIndex,
        selectedPlan
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRenewalPlans);


/***/ }),

/***/ 7174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var axios = __webpack_require__(97218);
const getCountryAndIp = async ()=>{
    try {
        let { data  } = await axios({
            url: "https://ipapi.co/json",
            method: "get"
        });
        return {
            type: "2",
            data: data
        };
    } catch (error2) {
        try {
            let { data: data1  } = await axios({
                url: "https://api.ip.sb/geoip?callback=",
                method: "get"
            });
            return {
                type: "1",
                data: data1
            };
        } catch (error1) {
            try {
                let { data: data2  } = await axios({
                    url: "https://ipinfo.io",
                    method: "get",
                    headers: {
                        Host: "ipinfo.io",
                        "User-Agent": "curl/7.83.1"
                    }
                });
                return {
                    type: "3",
                    data: data2
                };
            } catch (error) {
                return {
                    type: "500"
                };
            }
        }
    }
};
const countryAndIp = async ()=>{
    let obj = {
        ip: "209.141.54.129",
        country: "US",
        region: "Nevada",
        city: "Las Vegas",
        country_name: "United States"
    };
    try {
        let localCountryAndIp = localStorage.getItem("localCountryAndIp");
        if (localCountryAndIp != null) {
            return JSON.parse(localCountryAndIp);
        }
        let res = await getCountryAndIp();
        if (res.type == "1") {
            obj.ip = res.data.ip;
            obj.country = res.data.country_code;
            obj.region = res.data.country;
            obj.city = res.data.country;
            obj.country_name = res.data.country;
        } else if (res.type == "2") {
            obj.ip = res.data.ip;
            obj.country = res.data.country;
            obj.region = res.data.region != null ? res.data.region : res.data.city;
            obj.city = res.data.city;
            obj.country_name = res.data.country_name;
        } else if (res.type == "3") {
            obj.ip = res.data.ip;
            obj.country = res.data.country;
            obj.region = res.data.region;
            obj.city = res.data.city;
            obj.country_name = res.data.country;
        }
        if (res.type != "500") {
            localStorage.setItem("localCountryAndIp", JSON.stringify(obj));
        }
        return obj;
    } catch (error) {
        return obj;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (countryAndIp);


/***/ }),

/***/ 34556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ pickLatestExpireOrder; },
/* harmony export */   "Xm": function() { return /* binding */ resolveCardSubscription; },
/* harmony export */   "mw": function() { return /* binding */ resolveDeviceOrder; }
/* harmony export */ });
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/**
 * 同一台设备会有多张订单（首单 + 历次续费单），所以按设备匹配到的是「一组」订单。
 * 约定：**最新的关联单 = 过期时间最晚的那一张**。
 * 过期时间解析不出来的单不参与比较（避免脏数据把结果带偏）；
 * 全部解析不出来时才退回数组第一张，保证不返回空。
 */ const pickLatestExpireOrder = function() {
    let orders = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const list = Array.isArray(orders) ? orders : [];
    if (!list.length) return null;
    let best = null;
    let bestMs = -Infinity;
    list.forEach((row)=>{
        const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(row === null || row === void 0 ? void 0 : row.expire_time);
        if (!Number.isFinite(ms)) return;
        if (ms > bestMs) {
            bestMs = ms;
            best = row;
        }
    });
    return best || list[0] || null;
};
const toKey = (value)=>value == null || value === "" ? null : String(value);
/**
 * 取「当前设备」的关联订单。
 *
 * 匹配优先级：
 *   0. `order_id`（设备记录 / DeviceUser 上的订单主键）→ 直接命中订单表的 `id`
 *      ✅ Msafely 后端 `user-device` 自 2026-09-17 起已返回 `order_id`，
 *      这是**最准**的一步：后端已经指明「这台设备当前是哪张单」，不需要再猜。
 *   1. `device_id`（订单表 device_id ↔ 设备记录 id）→ 命中多张时取**过期时间最晚**的那张
 *      （order_id 取不到时的兜底，例如早期写入的 DeviceUser 没有该字段）
 *   2. iCloud 账号 + 到期时间
 *   3. iCloud 账号
 *
 * 全部匹配不到返回 null —— 不能退回「全局最晚的一张」，
 * 否则会把别的设备（比如安卓单）的到期时间与档位显示到当前设备上。
 *
 * @param {Object} params
 * @param {Array} params.orders - user-account-order 列表
 * @param {Object} [params.deviceUser] - localStorage DeviceUser（含 order_id / device_id / username）
 * @param {Object} [params.device] - 设备接口（user-device）记录，优先于 deviceUser
 * @param {string|number} [params.orderId] - 已知订单 id（优先级最高）
 * @param {string|number} [params.deviceId] - 已知设备 id
 * @param {string} [params.iCloudUsername] - 已知 iCloud 账号
 * @returns {Object|null}
 */ const resolveDeviceOrder = function() {
    let { orders , deviceUser , device , orderId , deviceId , iCloudUsername  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(orders) ? orders : [];
    if (!list.length) return null;
    var ref;
    // 0) 设备上的 order_id 直接对应订单主键（取不到就往下走）
    const targetOrderId = toKey(orderId) || toKey((ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) || toKey(deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.order_id);
    if (targetOrderId) {
        const byOrderId = list.find((item)=>{
            return toKey(item === null || item === void 0 ? void 0 : item.id) === targetOrderId;
        });
        if (byOrderId) return byOrderId;
    }
    // 1) 按设备 id 找到一组订单，取过期时间最晚的那张
    const targetDeviceId = toKey(deviceId) || toKey(device === null || device === void 0 ? void 0 : device.id) || toKey(device === null || device === void 0 ? void 0 : device.device_id) || toKey(deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id);
    if (targetDeviceId) {
        const byDevice = list.filter((item)=>{
            return toKey(item === null || item === void 0 ? void 0 : item.device_id) === targetDeviceId;
        });
        if (byDevice.length) return pickLatestExpireOrder(byDevice);
    }
    // 2) 退化为 iCloud 账号（+ 到期时间更精确）
    const username = iCloudUsername || (device === null || device === void 0 ? void 0 : device.iCloud_username) || (deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.username) || (deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.iCloud_username) || null;
    if (username) {
        const byAccount = list.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.icloud_account) === username;
        });
        if (byAccount.length) {
            const expireTime = (device === null || device === void 0 ? void 0 : device.expire_time) || (deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.expire_time) || null;
            if (expireTime) {
                const exact = byAccount.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.expire_time) === expireTime;
                });
                if (exact.length) return pickLatestExpireOrder(exact);
            }
            return pickLatestExpireOrder(byAccount);
        }
    }
    return null;
};
/**
 * Dashboard 卡片展示用的订阅信息：**设备接口优先，订单兜底**。
 *
 * 为什么以设备接口为准：`user-device` 现在直接返回
 * `order_id / product_name / order_level / expire_time / platform_type / subscription_status`，
 * 它就是「这台设备当前的订阅状态」，比从订单列表里挑一张更准、也更实时。
 * 订单仍用于补设备接口没有的字段（`merchant_no`（注册码行）/ `bill_card`（续费弹窗）等）。
 *
 * @param {Object} params
 * @param {Object} [params.order] - resolveDeviceOrder 得到的订单行
 * @param {Object} [params.device] - 设备接口（user-device）记录
 * @returns {Object} 可直接铺开给卡片用的对象
 */ const resolveCardSubscription = function() {
    let { order , device  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const base = order || {};
    if (!device) return base;
    var _product_name, _order_level, _expire_time;
    return {
        ...base,
        product_name: (_product_name = device.product_name) !== null && _product_name !== void 0 ? _product_name : base.product_name,
        order_level: (_order_level = device.order_level) !== null && _order_level !== void 0 ? _order_level : base.order_level,
        expire_time: (_expire_time = device.expire_time) !== null && _expire_time !== void 0 ? _expire_time : base.expire_time
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (resolveDeviceOrder)));


/***/ }),

/***/ 22518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NA": function() { return /* binding */ buildMsafelyPurchaseHref; },
/* harmony export */   "R4": function() { return /* binding */ fetchRenewProductIdForOrder; },
/* harmony export */   "T2": function() { return /* binding */ buildMsafelyRenewCheckoutHref; },
/* harmony export */   "TR": function() { return /* binding */ resolvePlanIndex; },
/* harmony export */   "mH": function() { return /* binding */ mapRenewalPlans; }
/* harmony export */ });
/* unused harmony export getPlanMonths */
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95629);
/* harmony import */ var src_utils_resolveUpgradeDeviceId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43756);


const getPlanMonths = (plan)=>{
    var ref, ref1;
    const nameMatch = (plan === null || plan === void 0 ? void 0 : (ref = plan.name) === null || ref === void 0 ? void 0 : ref.match(/(\d+)\s*Month/i)) || (plan === null || plan === void 0 ? void 0 : (ref1 = plan.name) === null || ref1 === void 0 ? void 0 : ref1.match(/(\d+)/));
    if (nameMatch) {
        const n = Number(nameMatch[1]);
        if ([
            1,
            3,
            12
        ].includes(n)) return n;
    }
    const days = Number(plan === null || plan === void 0 ? void 0 : plan.valid_days);
    if (Number.isFinite(days) && days > 0) {
        if (days >= 360) return 12;
        if (days >= 80) return 3;
        return Math.max(1, Math.round(days / 30));
    }
    return 1;
};
/** 月均价：向下取整到 2 位小数（不用四舍五入） */ const toFixed2 = (value)=>{
    const n = Number(value);
    if (!Number.isFinite(n)) return "0.00";
    return (Math.floor(n * 100 + Number.EPSILON) / 100).toFixed(2);
};
/**
 * plans-by-order 展示价（月均）
 * - SEVERE（全员 lapsed）：forceExpiredOver=true，划线用 renew_price
 * - 宽限期/有效：现价 = price + setup，无划线（不再用本地 expire_time 推算是否超 30 天）
 */ const mapRenewalPlans = function(apiPlans, expireTime) {
    let { forceExpiredOver =false  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const expiredOver = Boolean(forceExpiredOver);
    return (Array.isArray(apiPlans) ? apiPlans : []).map((plan)=>{
        const months = getPlanMonths(plan);
        const renew = Number(plan.renew_price) || 0;
        const setup = Number(plan.setup) || 0;
        const price = Number(plan.price) || 0;
        const currentTotal = price + setup;
        const originalTotal = expiredOver ? renew : null;
        return {
            productId: plan.id,
            name: plan.name || "",
            months,
            periodKey: months === 12 ? "Yearly" : months === 3 ? "Quarterly" : "Monthly",
            periodLabelKey: months === 12 ? "12 months" : months === 3 ? "3 months" : "1 month",
            titleKey: months === 12 ? "12 Months" : months === 3 ? "3 Months" : "1 Months",
            badgeKey: months === 12 ? "Best Value" : months === 3 ? "Most Popular" : null,
            monthlyPrice: toFixed2(currentTotal / months),
            monthlyOriginal: originalTotal != null ? toFixed2(originalTotal / months) : null,
            showOriginal: expiredOver && originalTotal != null
        };
    }).sort((a, b)=>a.months - b.months);
};
const resolvePlanIndex = function(plans, productName) {
    let { defaultMonths =1  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!(plans === null || plans === void 0 ? void 0 : plans.length)) return 0;
    // 有套餐名按数字解析；无名字用 defaultMonths（超 30 天续费页默认 3 个月，与 SpyX 一致）
    const match = productName === null || productName === void 0 ? void 0 : productName.match(/\d+/g);
    let months = defaultMonths;
    if (match === null || match === void 0 ? void 0 : match.length) {
        if (match[0] === "12") months = 12;
        else if (match[0] === "3") months = 3;
        else months = 1;
    }
    const idx = plans.findIndex((p)=>p.months === months);
    if (idx >= 0) return idx;
    return 0;
};
/** 按订单拉 plans-by-order，解析默认续费商品 id（renewId 必传） */ async function fetchRenewProductIdForOrder(order) {
    let { forceExpiredOver =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if ((order === null || order === void 0 ? void 0 : order.id) == null || (order === null || order === void 0 ? void 0 : order.id) === "") return null;
    try {
        var ref;
        const res = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .getPlansByOrder */ .hV)({
            order_id: order.id
        });
        const list = (res === null || res === void 0 ? void 0 : res.code) === 0 && Array.isArray(res.data) ? res.data : [];
        if (!list.length) return null;
        var _expire_time_raw;
        const expireTime = (_expire_time_raw = order.expire_time_raw) !== null && _expire_time_raw !== void 0 ? _expire_time_raw : order.expire_time;
        const plans = mapRenewalPlans(list, expireTime, {
            forceExpiredOver
        });
        const idx = resolvePlanIndex(plans, order.product_name);
        var ref1;
        return (ref1 = (ref = plans[idx]) === null || ref === void 0 ? void 0 : ref.productId) !== null && ref1 !== void 0 ? ref1 : null;
    } catch (e) {
        return null;
    }
}
/**
 * Msafely 官网的新购/续费入口。
 * Dashboard 不承载 /step/checkout 路由；续费使用新支付方式时，进入官网套餐页创建新订单。
 *
 * deviceId（设备包 id）必须带上：官网套餐页会把它透传到支付页，
 * 支付页建单时再带回后端，后端才会把这笔付款续到「原来那台设备」上。
 * 丢了它，后端会另开一个设备包（多绑定一个 package）。
 */ const buildMsafelyPurchaseHref = function() {
    let { locale , deviceId  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const webLocale = locale === "it-ch" ? "it" : locale;
    const localizedPricingLocales = new Set([
        "ar",
        "de",
        "es",
        "it",
        "jp",
        "kr",
        "pt",
        "ru",
        "tr",
        "tw"
    ]);
    const pricingPath = localizedPricingLocales.has(webLocale) ? "/".concat(webLocale, "/pricing") : "/pricing" || 0;
    const clientUrl = ("https://test-ms-web.gbyte.com.cn" || 0).replace(/\/$/, "");
    // 只接受真正的设备包 id（数字/非邮箱），绝不把邮箱当 device_id 传出去
    const id = (0,src_utils_resolveUpgradeDeviceId__WEBPACK_IMPORTED_MODULE_1__/* .isUpgradeDeviceId */ .nW)(deviceId) ? String(deviceId).trim() : "";
    const deviceQuery = id ? "?device_id=".concat(encodeURIComponent(id)) : "";
    return "".concat(clientUrl).concat(pricingPath).concat(deviceQuery);
};
/**
 * Msafely 官网的「续费支付页」直达入口（跳过官网套餐页，直接进 /payment/{productId}）。
 *
 * 与 buildMsafelyPurchaseHref 的区别：
 * - buildMsafelyPurchaseHref 落在官网套餐页，用户还要再选一次套餐（用于「过期引导购买」等未选套餐的场景）
 * - 本函数用于「用户已在 Dashboard 弹窗里选好套餐」的场景（my account 的「添加卡」），少一步
 *
 * 与 SpyX 的对齐关系：SpyX 的 buildRenewCheckoutHref 落在官网 /step/checkout/{productId}，
 * 但 msafely 官网没有 /step/checkout 路由，对应的支付页路径是 /payment/{productId}。
 *
 * deviceId（设备包 id）同样必须带上，理由见 buildMsafelyPurchaseHref。
 * 路径的多语言映射与官网 configs/urlMapping.js 的 '/payment' 项保持一致（注意法语是 /fr/paiement）。
 */ const PAYMENT_LOCALE_PATH = {
    ar: "/ar/payment",
    de: "/de/payment",
    es: "/es/payment",
    fr: "/fr/paiement",
    it: "/it/payment",
    jp: "/jp/payment",
    kr: "/kr/payment",
    pt: "/pt/payment",
    ru: "/ru/payment",
    tr: "/tr/payment",
    tw: "/tw/payment"
};
const buildMsafelyRenewCheckoutHref = function() {
    let { locale , productId , deviceId  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (productId == null || productId === "") return null;
    const webLocale = locale === "it-ch" ? "it" : locale;
    const paymentPath = PAYMENT_LOCALE_PATH[webLocale] || "/payment";
    const clientUrl = ("https://test-ms-web.gbyte.com.cn" || 0).replace(/\/$/, "");
    // 只接受真正的设备包 id（数字/非邮箱），绝不把邮箱当 device_id 传出去
    const id = (0,src_utils_resolveUpgradeDeviceId__WEBPACK_IMPORTED_MODULE_1__/* .isUpgradeDeviceId */ .nW)(deviceId) ? String(deviceId).trim() : "";
    const deviceQuery = id ? "?device_id=".concat(encodeURIComponent(id)) : "";
    return "".concat(clientUrl).concat(paymentPath, "/").concat(encodeURIComponent(productId)).concat(deviceQuery);
};


/***/ })

}]);